/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_UploadedInputs */



/**
* | output |
* | --- |
* | "Template file saved. Downloads now use your corporate design." |
*
* @param {Presentation_Template_Master_UploadedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_uploaded = /** @type {((inputs?: Presentation_Template_Master_UploadedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_UploadedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlagendatei gespeichert. Downloads nutzen jetzt Ihr Corporate Design.")
	return /** @type {LocalizedString} */ ("Template file saved. Downloads now use your corporate design.")
});